import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'upmarket-multi_user_education_banner_profile_picture_upload-submit';

/**
 * Event that gets triggered when the user uploads a new profile picture using the multi user homepage team education banner.
 */
export function trackUpmarketMultiUserEducationBannerProfilePictureUploadSubmit(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
